<template>
  <div class="root">
    <div class="backdrop"></div>
    <Fold1 />
    <Fold2 />
    <Fold3 />
    <Fold4 />
    <Fold5 />
    <Footer />
  </div>
</template>

<style lang="scss" scoped>
.root {
  // min-height: 100vh;
  .backdrop {
    z-index: -1;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      199.24deg,
      rgba(140, 180, 213, 0.6) 12.94%,
      rgba(212, 222, 241, 0.6) 36.87%,
      rgba(250, 239, 240, 0.6) 61.97%,
      rgba(254, 197, 129, 0.6) 87.06%
    );
    filter: blur(60px);
    background-attachment: fixed;
  }
}
</style>
<script>
// @ is an alias to /src
import Fold1 from "@/components/homefolds/fold1.vue";
import Fold2 from "@/components/homefolds/fold2.vue";
import Fold3 from "@/components/homefolds/fold3.vue";
import Fold4 from "@/components/homefolds/fold4.vue";
import Fold5 from "@/components/homefolds/fold5.vue";
import Footer from "@/components/footer/footer.vue";
export default {
  name: "Home",
  components: { Fold1, Fold2, Fold3, Fold4, Fold5, Footer },
  data() {
    return {};
  },
  mounted() {
    this.$gtag.pageview({
      page_path: "/",
    });
  },
  created() {
    document.title = "Florenge Collection | Curnon Watch";
  },
};
</script>
